angular.module( 'acme.view.application.membership.categories.create.pricing', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.categories.create.pricing.controllers'
])

.config(function config( $stateProvider ) {

  var membershipCategoriesCreatePricing = {
    name: 'application.membership.categories.create.pricing',
    url: '/pricing',
    views: {
      "subview-main": {
        controller: 'MembershipCategoriesCreatePricingController',
        templateUrl: 'views/application/views/membership/categories/create/pricing/pricing.tpl.html'
      }
    },
    data: {
      pageTitle: 'Create Membership Level'
    }
  },
  membershipCategoriesEditPricing = {
    name: 'application.membership.categories.edit.pricing',
    url: '/pricing',
    views: {
      "subview-main": {
        controller: 'MembershipCategoriesCreatePricingController',
        templateUrl: 'views/application/views/membership/categories/create/pricing/pricing.tpl.html'
      }
    },
    data: {
      pageTitle: 'Edit Membership Level'
    }
  };

    $stateProvider
      .state(membershipCategoriesCreatePricing)
      .state(membershipCategoriesEditPricing);
});
